module.exports = __webpack_public_path__ + "static/media/sound_icon_white.f2da3046.svg";